import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const triggerProductSync = async (review: boolean, instanceId?: string): Promise<void> => {
  try {
    const res = await fetch(`${API_URL}/items/sync`, {
      method: 'POST',
      body: JSON.stringify({ review: review, ...(instanceId && { instance_id: instanceId }) }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!res.ok || res.status !== Status.ACCEPTED) {
      const result = await res.json();
      throw new Error(result.message);
    }
  } catch (e) {
    if (e) {
      throw new Error(e.message);
    } else {
      throw new Error('Could not sync with Assure 65');
    }
  }
};
